/*
 * @Author: yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-06-04 17:53:19
 * @LastEditors: yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-06-11 20:45:41
 * @FilePath: \MPC-monorepo\features\mpc-common\src\features\MPCDemand\SupplierQuoteButton\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useState } from 'react';
import { Button, Tag, Input, Space, Message } from '@bedrock/components';
import { Edit, Eye } from '@bedrock/icons-react';
import { apiService, defs } from '@mpc/common/src/services';
import { useMemoizedFn, useRequest, useControllableValue } from 'ahooks';
import { QuoteTableDrawerOpen } from '../DemandConfigQuoteTable/quoteDrawer';

export default function (props: {
  onCommit?: (data: any) => void;
  detail: defs.OutsourceDemandDetailsResDto;
  formData?: any;
}) {
  const [loading, setLoading] = useState(false);
  const { detail, onCommit, formData } = props;
  const cooperateAccountList = detail?.demand_plan_info?.cooperate_accounts;
  const supplierId = detail.demand_suppliers?.[0]?.supplier_id;
  const demandId = detail.id;

  const onOpenQuoteDrawer = useMemoizedFn(async () => {
    setLoading(true);
    let res;
    try {
      res = await apiService.outsourceDemandGetQuoteTableData({
        demand_id: demandId,
        supplier_id: supplierId,
      });
    } catch (error) {
      setLoading(false);
    }
    setLoading(false);

    if (!res.data) {
      Message.error('获取报价明细失败');
      return;
    }
    const { columns, pre_fill_data, temp_data, template_type, last_temp_save_time} = res.data;
    const newValue = temp_data?.length ? temp_data : pre_fill_data || [];
    // 判断如果newValue里不包含pre_fill_data一样的cooperate_account_id，则添加pre_fill_data
    const addPreCooperateIdList = pre_fill_data.filter((item) => {
      return !newValue.some((n) => +n.cooperateAccountId === +item.cooperateAccountId);
    });
    const newData = [...newValue, ...addPreCooperateIdList];
    const { close } = QuoteTableDrawerOpen.show({
      currency: formData?.currency,
      data: newData || [],
      addTemplateList: pre_fill_data,
      lastTempSaveTime: last_temp_save_time,
      onTempSave: async (newData) => {
        const res = await apiService.outsourceDemandSaveQuoteTableData({
          operate_type: 'TEMP_SAVE',
          demand_id: demandId,
          supplier_id: supplierId,
          data: newData,
        });
      },
      onCommit: async (newData) => {
        const res = await apiService.outsourceDemandSaveQuoteTableData({
          operate_type: 'SAVE',
          demand_id: demandId,
          supplier_id: supplierId,
          data: newData,
        });
        close();
        onCommit?.(res);
      },
      quoteTableColumns: columns,
      cooperateAccountList: cooperateAccountList as any,
      quoteTableType: 'supplierQuote',
      templateType: template_type,
      supplierId,
      demandId,
    });
  });

  return (
    <Space size={8}>
      <Button
        loading={loading}
        type="checked"
        color="primary"
        icon={<Edit />}
        onClick={onOpenQuoteDrawer}
      >
        填写明细
      </Button>
    </Space>
  );
}
